var defaultHeight = 650; 
var text = $(".product__description_content");
var textHeight = text[0].scrollHeight; 
var button = $(".show_hide");

text.css({"max-height": defaultHeight, "overflow": "hidden"});

button.on("click", function(){
  var newHeight = 0;
  var buttonText = "";
  
  if (text.hasClass("active")) {
    newHeight = defaultHeight;
    text.removeClass("active");
    buttonText = "See More";
  } else {
    newHeight = textHeight;
    text.addClass("active");
    buttonText = "See Less";
  }
  text.animate({
    "max-height": newHeight
  }, 500);
  button.text(buttonText);
});